import IWaveStat from '@/constants/integrations/IWaveStat';
import translate from '@/lib/intl/translate';

const IWaveSummaryRenderList: {
  stat: IWaveStat;
  header: string;
  description: string;
}[] = [
  // iWave is not returning all of the scores. Commenting them out for now
  // as we hope to get them soon.
  // {
  //   stat: IWaveStat.SCORE,
  //   header: translate('IWAVE_SCORE_BREAKDOWN_SCORE_HEADER'),
  //   description: translate('IWAVE_SCORE_BREAKDOWN_SCORE_DESCRIPTION'),
  // },
  {
    stat: IWaveStat.PROPENSITY,
    header: translate('IWAVE_SCORE_BREAKDOWN_PROPENSITY_HEADER'),
    description: translate('IWAVE_SCORE_BREAKDOWN_PROPENSITY_DESCRIPTION'),
  },
  {
    stat: IWaveStat.AFFINITY,
    header: translate('IWAVE_SCORE_BREAKDOWN_AFFINITY_HEADER'),
    description: translate('IWAVE_SCORE_BREAKDOWN_AFFINITY_DESCRIPTION'),
  },
  {
    stat: IWaveStat.CAPACITY,
    header: translate('IWAVE_SCORE_BREAKDOWN_CAPACITY_HEADER'),
    description: translate('IWAVE_SCORE_BREAKDOWN_CAPACITY_DESCRIPTION'),
  },
  // {
  //   stat: IWaveStat.PLANNED_GIVING,
  //   header: translate('IWAVE_SCORE_BREAKDOWN_PLANNED_GIVING_HEADER'),
  //   description: translate('IWAVE_SCORE_BREAKDOWN_PLANNED_GIVING_DESCRIPTION'),
  // },
  // {
  //   stat: IWaveStat.RFM,
  //   header: translate('IWAVE_SCORE_BREAKDOWN_RFM_HEADER'),
  //   description: translate('IWAVE_SCORE_BREAKDOWN_RFM_DESCRIPTION'),
  // },
];

export default IWaveSummaryRenderList;
